import { useState, useEffect, useRef } from "react";

/* ─────────────────────────────────────────
   IMAGE IMPORTS
───────────────────────────────────────── */
import CommittedImg      from "../../../asset/images/home/committed-esp.webp";

import BizCleanAir       from "../../../asset/images/home/biz-clean-air.webp";
import BizTraffic        from "../../../asset/images/home/biz-traffic.webp";
import BizHydrogen       from "../../../asset/images/home/biz-hydrogen.webp";
import BizPower          from "../../../asset/images/home/biz-power.webp";
import BizDefence        from "../../../asset/images/home/biz-defence.webp";
import BizSoftware       from "../../../asset/images/home/biz-software.webp";

import AboutTeamImg      from "../../../asset/images/home/about-team.webp";

import SkiesCement       from "../../../asset/images/home/skies-cement.webp";
import SkiesSteel        from "../../../asset/images/home/skies-steel.webp";
import SkiesPower        from "../../../asset/images/home/skies-power.webp";
import SkiesPaper        from "../../../asset/images/home/skies-paper.webp";
import SkiesValue        from "../../../asset/images/home/skies-value.webp";

import ExportMap         from "../../../asset/images/home/export-map.webp";

import News1Img          from "../../../asset/images/home/news-1.webp";
import News2Img          from "../../../asset/images/home/news-2.webp";
import News3Img          from "../../../asset/images/home/news-3.webp";

/* Contact strip icons */
import ContactIconPhone  from "../../../asset/images/home/icon-contact-phone.svg";
import ContactIconEmail  from "../../../asset/images/home/icon-contact-email.svg";
import ContactIconClock  from "../../../asset/images/home/icon-contact-clock.svg";

/* ─────────────────────────────────────────
   CSS
───────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ahp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }
  .ahp a { text-decoration: none; }
  .ahp img { display: block; max-width: 100%; }

  /* ── Layout ── */
  .ahp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }
  .ahp-sec-white { background: #fff; }
  .ahp-sec-gray  { background: #F7F7F7; }

  /* ══ HERO ══ */
  .ahp-hero {
    position: relative; width: 100%; height: 500px; min-height: 500px;
     overflow: hidden;
    margin-top: 0px;
  }
  .ahp-hero-iframe {
    position: absolute; inset: 0; pointer-events: none !important;
  }
  .ahp-hero-iframe iframe {
    width: 100%; height: 100%; border: 0; pointer-events:none !important;
  }

  /* ══ COMMITTED ══ */
  .ahp-sec-committed { padding: 66px 0 80px 0; }
  .ahp-committed-grid {
    display: grid; grid-template-columns: 1fr 1fr;
    gap: 100px; align-items: center;
  }
  .ahp-committed-img {
    width: 100%; height: 500px;
    object-fit: cover; border-radius: 10px; display: block;
  }
  .ahp-committed-title {
    font-size: 32px; font-weight: 500;
    line-height: 120%; margin-bottom: 15px; color: #202020;
  }
  .ahp-committed-title span { color: #EB2019; }
  .ahp-committed-body {
    font-size: 18px; color: #202020;
    line-height: 160%; margin-bottom: 30px;
  }
  .ahp-btn-red {
    display: inline-block; background: #EB2019;
    color: #fff !important; padding: 14px 20px;
    border-radius: 10px; font-size: 16px; font-weight: 500;
    transition: background .2s;
  }
  .ahp-btn-red:hover { background: #c0150e; }

  /* ══ OUR BUSINESS ══ */
  .ahp-sec-business { padding: 66px 0 80px 0; }
  .ahp-sec-title {
    font-size: 40px; font-weight: 600;
    text-align: center; margin-bottom: 60px; color: #202020;
  }
  .ahp-biz-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px;
  }

  /* ══ IMAGE CARD (shared: business + skies) ══ */
  .ahp-card {
    position: relative; display: block;
    border-radius: 12px; overflow: hidden; cursor: pointer;
  }
  .ahp-card-img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
    transition: transform .4s ease;
  }
  .ahp-card:hover .ahp-card-img { transform: scale(1.06); }
  .ahp-card-bar {
    position: absolute; bottom: 20px; left: 20px; right: 20px;
    display: flex; align-items: center; justify-content: space-between;
    background: #fff; border-radius: 10px; padding: 8px 8px 8px 24px;
    transition: background .25s;
  }
  .ahp-card:hover .ahp-card-bar { background: #EB2019; }
  .ahp-card-label {
    font-size: 20px; font-weight: 500; color: #202020;
    transition: color .25s;
  }
  .ahp-card:hover .ahp-card-label { color: #fff; }
  .ahp-card-arrow {
    width: 44px; height: 44px; border-radius: 6px;
    background: #EB2019; display: flex; align-items: center;
    justify-content: center; flex-shrink: 0; transition: background .25s;
  }
  .ahp-card:hover .ahp-card-arrow { background: #fff; }
  .ahp-card-arrow svg path {
    stroke: #fff; transition: stroke .25s;
  }
  .ahp-card:hover .ahp-card-arrow svg path { stroke: #EB2019; }

  /* Card heights */
  .ahp-card-h210 { height: 320px; }
  .ahp-card-h230 { height: 280px; }

  /* ══ ABOUT ══ */
  .ahp-sec-about { padding: 120px 0 120px 0; }

  /* 3-col grid — top aligned so heading card can overlap photo */
  .ahp-about-grid {
    display: grid; grid-template-columns: 1fr 1fr 1fr;
    gap: 64px; align-items: center;
  }

  /* Col 1 — heading card + body text */
  .ahp-about-col1 { position: relative; align-items: center; }

  /* White card that visually overlaps the photo from behind */
  .ahp-about-heading-card {
    background: #fff;
    padding: 20px 24px 20px 24px;
    position: relative; z-index: 2;
    margin-bottom: 30px;
    margin-right: -120px;
    border: 0.5px solid #DEDEDE;
  }
  .ahp-about-title {
    font-size: 26px; font-weight: 500;
    line-height: 120%; color: #202020; margin: 0;
  }
  .ahp-about-title span { color: #EB2019; }
  .ahp-about-body {
    font-size: 16px; color: #000000; line-height: 160%;
    border-left: 1px solid #EBEBEB; padding-left: 26px;
  }

  /* Col 2 — photo sits behind heading card */
  .ahp-about-col2 { margin-top: 0px; position: relative; z-index: 1; }
  .ahp-about-img {
    width: 100%; height: auto;
    object-fit: cover; border-radius: 14px; display: block;
  }

  /* Col 3 — stats */
  .ahp-stat-num {
    font-size: 62px; font-weight: 700;
    color: #EB2019;
  }
  .ahp-stat-label {
    font-size: 22px; font-weight: 500; color: #202020;
    margin-top: 0px; letter-spacing: 1px; text-transform: uppercase;
  }
  .ahp-stat-second { margin-top: 40px; }

  /* ══ KEEPING OUR SKIES CLEAN ══ */
  .ahp-sec-skies { padding: 66px 0 80px 0; }
  .ahp-skies-header {
    display: flex; gap: 143px;
    align-items: flex-start; margin-bottom: 60px;
  }
  .ahp-skies-title {
    font-size: 40px; font-weight: 600;
    color: #202020; flex-shrink: 0;
  }
  .ahp-skies-divider {
    border-left: 1px solid #EB2019; padding-left: 34px; flex: 1;
  }
  .ahp-skies-desc {
    font-size: 16px; color: #202020; line-height: 160%;
  }
  .ahp-skies-grid-top {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px;
  }
  .ahp-skies-grid-bot {
    display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-top: 30px;
  }

  /* ══ EXPORT ══ */
  .ahp-sec-export { padding: 66px 0px 80px 0px; }
  .ahp-export-map { width: 80%; display: block; margin:0 auto; }

  /* ══ NEWS ══ */
  .ahp-sec-news { padding: 80px 0 80px 0; }
  .ahp-news-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px;
  }
  .ahp-news-card {
    display: block; background: #F5F5F5;
    border-radius: 10px; overflow: hidden;
    color: #202020;
  }
  .ahp-news-img {
    width: 100%; height: 220px;
    object-fit: cover; display: block;
  }
  .ahp-news-body { padding: 30px 0px 0px; }
  .ahp-news-title {
    font-size: 20px; font-weight: 500;
    line-height: 140%; margin-bottom: 15px; color: #202020;
  }
  .ahp-news-date { font-size: 14px; color: #747474; margin-bottom: 20px; }
  .ahp-news-read {
    display: inline-flex; align-items: center; gap: 14px;
    font-size: 16px; font-weight: 600; color: #EB2019; transition: gap .2s;
  }
  .ahp-news-card:hover .ahp-news-read { gap: 10px; }

  /* ══ CONTACT STRIP ══ */
  .ahp-sec-contact { padding: 120px 0 120px 0; }
  .ahp-contact-row {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px;
  }
  .ahp-contact-box {
    display: flex; flex-direction: column;
    align-items: center; text-align: center;
  }
  .ahp-contact-icon {
    width: 84px; height: 84px; background: #FDE8E8;
    border-radius: 16px; display: flex;
    align-items: center; justify-content: center;
    flex-shrink: 0; margin-bottom: 30px;
  }
  .ahp-contact-icon img { width: 30px; height: 30px; object-fit: contain; display: block; }
  .ahp-contact-label { font-size: 16px; color: #000000; margin-bottom: 15px; }
  .ahp-contact-value {
    font-size: 24px; font-weight: 500; color: #EB2019;
  }
  .ahp-contact-value-sm {
    font-size: 24px; font-weight: 500; color: #EB2019;
  }
    // ///////////////////////////
    /* ══ HERO ══ */
.ahp-hero {
  position: relative;
  width: 100%;
  height: 500px;
  min-height: 500px;
  overflow: hidden;
  margin-top: 0;
}
.ahp-hero-iframe {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.ahp-hero-iframe iframe {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: max(100vw, 889px);     /* 500px x 16/9, keeps the video filling the width */
  height: max(500px, 56.25vw);  /* 100vw x 9/16, keeps the video filling the height */
  border: 0;
}

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ahp-inner              { padding: 0 32px; }
    .ahp-sec-committed      { padding: 48px 0; }
    .ahp-sec-business       { padding: 48px 0; }
    .ahp-sec-about          { padding: 48px 0; }
    .ahp-sec-skies          { padding: 48px 0; }
    .ahp-sec-export         { padding: 48px 0; }
    .ahp-sec-news           { padding: 48px 0; }
    .ahp-sec-contact        { padding: 48px 0; }
    .ahp-committed-grid     { grid-template-columns: 1fr; gap: 40px; }
    .ahp-committed-img      { height: 240px; }
    .ahp-committed-title    { font-size: 22px; }
    .ahp-biz-grid           { grid-template-columns: 1fr 1fr; }
    .ahp-about-grid         { grid-template-columns: 1fr; gap: 40px; }
    .ahp-about-col2         { margin-top: 0; }
    .ahp-about-heading-card { padding: 0 0 20px 0; margin-bottom: 20px; margin-right: 0; }
    .ahp-about-img          { height: 280px; }
    .ahp-skies-header       { flex-direction: column; gap: 15px; margin-bottom: 40px;  }
    .ahp-skies-divider { border:none;     padding-left: 0px;}
    .ahp-skies-desc {     font-size: 14px;}
    .ahp-skies-title        { font-size: 20px; }
    .ahp-skies-grid-top     { grid-template-columns: 1fr 1fr; }
    .ahp-skies-grid-bot     { grid-template-columns: 1fr 1fr; }
    .ahp-card-arrow { width: 32px; height:32px;}

    .ahp-card-label { font-size: 16px;}
    .ahp-news-grid          { grid-template-columns: 1fr 1fr; }
    .ahp-contact-row        { grid-template-columns: 1fr 1fr 1fr ; gap: 32px; }
    .ahp-contact-value { font-size: 16px;}
    .ahp-contact-value-sm { font-size: 16px;}
    .ahp-contact-icon {     width: 60px;height:60px;}
    .ahp-sec-title          { font-size: 24px; margin-bottom: 32px; }
    .ahp-stat-num { font-size: 44px;}
    .ahp-stat-label { font-size: 20px;}
    .ahp-stat-second { margin-top: 20px;}
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ahp-inner              { padding: 0 16px; }
    .ahp-committed-grid     { grid-template-columns: 1fr; gap: 30px; }
    .ahp-committed-title    { font-size: 20px; }
    .ahp-btn-red            { font-size: 14px; padding: 11.5px 20px; }
    .ahp-committed-body     { font-size: 14px; }
    .ahp-sec-committed      { padding: 30px 0px 60px 0px; }
    .ahp-sec-title          { font-size: 20px; text-align: left; margin-bottom: 30px; }
    .ahp-biz-grid           { gap: 20px; }
    .ahp-card-label         { font-size: 14px; }
    .ahp-card-bar           { padding: 10px; bottom: 10px; left: 10px; right: 10px; }
    .ahp-card-arrow         { width: 23px; height: 23px; }
    .ahp-sec-business       { padding: 30px 0; }
    .ahp-card-h210          { height: 213px; }
    .ahp-sec-about          { padding: 60px 0; }
        .ahp-about-img { height:502px;}
    .ahp-about-title { font-size:20px; line-height:120%;}
    .ahp-about-grid         { grid-template-columns: 1fr; gap: 30px; }
    .ahp-about-col2         { margin-top: 0; }
    .ahp-about-heading-card { padding: 0 0 0px 0; margin-bottom: 20px; margin-right: 0;border:none; }
    .ahp-about-body { border:none;font-size:14px;padding-left: 0px;}
    .ahp-sec-skies           { padding: 30px 0; }
    .ahp-sec-export         { padding: 60px 0; }
    .ahp-sec-news           { padding: 30px 0; }
    .ahp-news-body {     padding: 15px 0px 0px;}
    .ahp-news-title { font-size: 16px;}
    .ahp-news-date { margin-bottom: 14px;}
    .ahp-news-read { font-size: 14px;}
    .ahp-sec-contact         { padding: 60px 0; }
    .ahp-biz-grid           { grid-template-columns: 1fr; }
    .ahp-skies-header       { flex-direction: column; gap: 15px;    margin-bottom: 20px;  }
    .ahp-skies-grid-top     { grid-template-columns: 1fr;     gap: 20px; }
    .ahp-skies-grid-bot     { grid-template-columns: 1fr; }
    .ahp-news-grid          { grid-template-columns: 1fr; }
    .ahp-stat-num           { font-size: 62px; }
    .ahp-stat-label { font-size: 20px; }
    .ahp-stat-second {     margin-top: 20px;}
    .ahp-contact-icon {     width: 65px; height:65px; margin-bottom: 15px; }
    .ahp-contact-box { text-align: left;     align-items: start;}
    .ahp-contact-label { font-size: 14px; }

         .ahp-contact-row { gap: 30px;  grid-template-columns: 1fr  ;}
        
    .ahp-contact-value      { font-size: 20px; }
    .ahp-contact-value-sm   { font-size: 20px; }
  }
`;

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */
const BIZ_CARDS = [
  { label: "Clean Air",                      img: BizCleanAir, href: "/products"                                  },
  { label: "Traffic Enforcement",            img: BizTraffic,  href: "https://adortraffic.com/"                   },
  { label: "Hydrogen Power Source",          img: BizHydrogen, href: "https://yonderh2.com/"                      },
  { label: "Power & Surveillance Solutions", img: BizPower,    href: "/power-surveillance/hp-series"     },
  { label: "Defence",                        img: BizDefence,  href: "/defence/ador-defence"                              },
  { label: "Software Innovation",            img: BizSoftware, href: "/software-innovation"                       },
];

const SKIES_CARDS = [
  { label: "Cement Industry Solutions",       img: SkiesCement, href: "/products"                         },
  { label: "Steel Industry Solutions",        img: SkiesSteel,  href: "/products"                         },
  { label: "Power Sector Solutions",          img: SkiesPower,  href: "/products"                         },
  { label: "Pulp & Paper Industry Solutions", img: SkiesPaper,  href: "/products"                         },
  { label: "Value Added Services",            img: SkiesValue,  href: "/products/value-added-services"    },
];

const NEWS = [
  {
    img:   News1Img,
    title: "Ador makes a 51% equity investment in pioneering Australian Traffic Safety company",
    date:  "March 26, 2024",
    href:  "/news/ador-equity-traffic-safety",
  },
  {
    img:   News2Img,
    title: "Motorists' mobile phone use is today's 'drink-driving', authorities say",
    date:  "March 26, 2024",
    href:  "/news/motorists-mobile-phone-driving",
  },
  {
    img:   News3Img,
    title: "Acusensus featured in cover story of the latest issue of Traffic Technology International",
    date:  "March 26, 2024",
    href:  "/news/acusensus-traffic-technology",
  },
];

/* ─────────────────────────────────────────
   COUNTER HOOK
───────────────────────────────────────── */
function useCounter(target, duration, active) {
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!active) return;
    let t0 = null;
    const raf = (ts) => {
      if (!t0) t0 = ts;
      const p = Math.min((ts - t0) / duration, 1);
      setV(Math.floor(p * target));
      if (p < 1) requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }, [active, target, duration]);
  return v;
}

/* ─────────────────────────────────────────
   IMAGE CARD COMPONENT
───────────────────────────────────────── */
function ImgCard({ label, img, href, heightClass = "ahp-card-h210" }) {
  return (
    <a href={href} className={`ahp-card ${heightClass}`}>
      <img src={img} alt={label} className="ahp-card-img" />
      <div className="ahp-card-bar">
        <span className="ahp-card-label">{label}</span>
        <span className="ahp-card-arrow">
          <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
            <path d="M2 12L12 2M12 2H5M12 2V9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>
    </a>
  );
}

/* ─────────────────────────────────────────
   NEWS CARD COMPONENT
───────────────────────────────────────── */
function NewsCard({ news }) {
  return (
    <a href={news.href} className="ahp-news-card">
      <img src={news.img} alt={news.title} className="ahp-news-img" />
      <div className="ahp-news-body">
        <h3 className="ahp-news-title">{news.title}</h3>
        <p className="ahp-news-date">{news.date} /// No Comments</p>
        <span className="ahp-news-read">
          Read More
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="#EB2019" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>
    </a>
  );
}

/* ─────────────────────────────────────────
   MAIN PAGE COMPONENT
───────────────────────────────────────── */
export default function AdorHomePage() {
  const [statsOn, setStatsOn] = useState(false);
  const statsRef = useRef(null);
  const v6   = useCounter(6,   1400, statsOn);
  const v250 = useCounter(250, 2000, statsOn);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setStatsOn(true); },
      { threshold: 0.3 }
    );
    if (statsRef.current) obs.observe(statsRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="ahp">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      {/* <section className="ahp-hero">
        <div className="ahp-hero-iframe">
          <iframe
            src="https://www.youtube.com/embed/WMRm-FtAbX0?autoplay=1&mute=1&loop=1&playlist=WMRm-FtAbX0&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Ador Powertron Hero"
          />
        </div>
      </section> */}
      <section className="ahp-hero">
  <div className="ahp-hero-iframe">
    <iframe
      src="https://www.youtube.com/embed/ME4LJWTZjas?autoplay=1&mute=1&loop=1&playlist=ME4LJWTZjas&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
      allow="autoplay; encrypted-media"
      allowFullScreen
      title="Ador Powertron Hero"
    />
  </div>
</section>

      {/* ══ 2. COMMITTED FOR BETTER AIR ══ */}
      <section className="ahp-sec-committed ahp-sec-white">
        <div className="ahp-inner">
          <div className="ahp-committed-grid">
            <div>
              <img src={CommittedImg} alt="ESP Power Supply" className="ahp-committed-img" />
            </div>
            <div>
              <h2 className="ahp-committed-title">
                <span>Ador</span> is Committed for Better Air
              </h2>
              <p className="ahp-committed-body">
                The function of Electrostatic Precipitator (ESP) is to capture suspended
                particulate matter like dust, fly-ash, aerosols etc. from exhaust gases,
                typically from that of an industrial Boiler.
              </p>
              <a href="/products" className="ahp-btn-red">Explore Ador Air</a>
            </div>
          </div>
        </div>
      </section>

      {/* ══ 3. OUR BUSINESS ══ */}
      <section className="ahp-sec-business ahp-sec-gray">
        <div className="ahp-inner">
          <h2 className="ahp-sec-title">Our Business</h2>
          <div className="ahp-biz-grid">
            {BIZ_CARDS.map((c, i) => (
              <ImgCard key={i} label={c.label} img={c.img} href={c.href} heightClass="ahp-card-h210" />
            ))}
          </div>
        </div>
      </section>

      {/* ══ 4. ABOUT — col1: heading card + body | col2: photo | col3: stats ══ */}
      <section className="ahp-sec-about ahp-sec-white">
        <div className="ahp-inner">
          <div className="ahp-about-grid">

            {/* Col 1 — white heading card overlaps photo + body text below */}
            <div className="ahp-about-col1">
              <div className="ahp-about-heading-card">
                <h3 className="ahp-about-title">
                  <span>Ador Powertron:</span>{" "}
                  Helping Make India Smarter, Cleaner And More Secure
                </h3>
              </div>
              <p className="ahp-about-body">
                At Ador Powertron, We Are Driven By A Commitment To Help Make The World A
                Better Place. Our Focus On Innovation And Continues Improvement Has Helped
                Place Us At The Forefront Of Some Of The Industry Sectors Which We Serve.
                We Have Successfully Created Products That Have Fostered A Technological
                Change In The Operations Of Pollution Control And Road Safety Management.
                Our Mission Is To Transform Industry Challenges Into Opportunities, Whilst
                Helping Facilities A Sustainable Future.
              </p>
            </div>

            {/* Col 2 — team photo */}
            <div className="ahp-about-col2">
              <img src={AboutTeamImg} alt="Ador Powertron Team" className="ahp-about-img" />
            </div>

            {/* Col 3 — animated counters */}
            <div ref={statsRef}>
              <div>
                <div className="ahp-stat-num">{v6}</div>
                <div className="ahp-stat-label">Business Verticals</div>
              </div>
              <div className="ahp-stat-second">
                <div className="ahp-stat-num">{v250}+</div>
                <div className="ahp-stat-label">Highly Skilled Employees</div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ══ 5. KEEPING OUR SKIES CLEAN ══ */}
      <section className="ahp-sec-skies ahp-sec-gray">
        <div className="ahp-inner">
          <div className="ahp-skies-header">
            <h2 className="ahp-skies-title">Keeping Our Skies Clean</h2>
            <div className="ahp-skies-divider">
              <p className="ahp-skies-desc">
                ADOR POWERTRON Ltd., an ISO 9001 certified company, is one of the largest
                manufacturer and supplier of Transformer-Rectifier (T/R) sets and controls in the world.
              </p>
            </div>
          </div>
          <div className="ahp-skies-grid-top">
            {SKIES_CARDS.slice(0, 3).map((c, i) => (
              <ImgCard key={i} label={c.label} img={c.img} href={c.href} heightClass="ahp-card-h230" />
            ))}
          </div>
          <div className="ahp-skies-grid-bot">
            {SKIES_CARDS.slice(3).map((c, i) => (
              <ImgCard key={i} label={c.label} img={c.img} href={c.href} heightClass="ahp-card-h210" />
            ))}
          </div>
        </div>
      </section>

      {/* ══ 6. OUR EXPORT ══ */}
      <section className="ahp-sec-export ahp-sec-white">
        <div className="ahp-inner">
          <h2 className="ahp-sec-title">Our Export</h2>
          <img src={ExportMap} alt="Ador Powertron Export Map" className="ahp-export-map" />
        </div>
      </section>

      {/* ══ 7. NEWS & UPDATE ══ */}
      <section className="ahp-sec-news ahp-sec-gray">
        <div className="ahp-inner">
          <h2 className="ahp-sec-title">News &amp; Update</h2>
          <div className="ahp-news-grid">
            {NEWS.map((n, i) => <NewsCard key={i} news={n} />)}
          </div>
        </div>
      </section>

      {/* ══ 8. CONTACT STRIP ══ */}
      <section className="ahp-sec-contact ahp-sec-white">
        <div className="ahp-inner">
          <div className="ahp-contact-row">

            {/* Phone */}
            <div className="ahp-contact-box">
              <div className="ahp-contact-icon">
                <img src={ContactIconPhone} alt="Phone" />
              </div>
              <p className="ahp-contact-label">Have Questions? Call us.</p>
              <a href="tel:+919763729538" className="ahp-contact-value">+91 9763729538</a>
            </div>

            {/* Email */}
            <div className="ahp-contact-box">
              <div className="ahp-contact-icon">
                <img src={ContactIconEmail} alt="Email" />
              </div>
              <p className="ahp-contact-label">Looking for support?</p>
              <a href="mailto:info@adorpower.com" className="ahp-contact-value-sm">info@adorpower.com</a>
            </div>

            {/* Hours */}
            <div className="ahp-contact-box">
              <div className="ahp-contact-icon">
                <img src={ContactIconClock} alt="Clock" />
              </div>
              <p className="ahp-contact-label">We're open from</p>
              <span className="ahp-contact-value">Monday to Friday</span>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}